import { EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Box, Text } from 'atoms';
import { StatusAction } from 'components';
import { ACL } from 'components/common';
import { getLocalDate, getLocalTime } from 'utils/helpers';

export const DriverTableConfig = [
	{
		title: 'Driver Name',
		dataIndex: 'driver_name',
		key: 'driver_name',
		hidden: false,
		render: (driver_name) => <Text overFlow="hidden">{driver_name || ''}</Text>,
	},
	{
		title: 'Vendor',
		dataIndex: 'vendor_name',
		key: 'vendor_name',
		hidden: false,
		render: (vendor_name) => <Text overFlow="hidden">{vendor_name || ''}</Text>,
	},
	{
		title: 'Mobile',
		dataIndex: 'mobile_no',
		key: 'mobile_no',
		hidden: false,
		render: (mobile_no) => <Text overFlow="hidden">{mobile_no || ''}</Text>,
	},
	{
		title: 'Vehicle Type',
		dataIndex: 'vehicle_type',
		key: 'vehicle_type',
		hidden: false,
		render: (vehicle_type) => <Text overFlow="hidden">{vehicle_type || ''}</Text>,
	},
	{
		title: 'username',
		dataIndex: 'username',
		key: 'username',
		hidden: false,
		render: (username) => <Text overFlow="hidden">{username || ''}</Text>,
	},
	{
		title: 'Created at',
		dataIndex: 'created_at',
		key: 'created_at',
		hidden: false,
		render: (created_at) => (
			<Box>
				<Text overFlow="hidden">{getLocalDate(created_at)}</Text>

				<Text overFlow="hidden" fontStyle="italic">
					{getLocalTime(created_at)}
				</Text>
			</Box>
		),
	},
	{
		title: 'View',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => (
			<Link to={`/drivers/${id}`}>
				<EyeOutlined />
			</Link>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id, record) => (
			<ACL action="update" module="driver">
				<StatusAction statusData={record?.is_active} userType="driver" id={id} />
			</ACL>
		),
	},
];
